import React from "react";
import './css/CoursesStyle.css';
import books from './images/vigyan-vriksh-book.svg';
import videolect from './images/vigyan-vriksh-video-lecture.svg';
import testseries from './images/vigyan-vriksh-test-series.svg';
import quebank from './images/vigyan-vriksh-que-bank.svg';

function Courses (){
    return (
        <div className="category-box">
            <div className="container">
                <div className="text-center mb-5">
                    <h2 className="fw-bold section-title">Explore Top Courses <span>Categories</span></h2>
                    <p className="text-muted">Discover diverse course categories designed to match your learning goals and career growth.</p>
                </div>
                <div className="row g-4">
                    <div className="col-md-6 col-lg-3">
                        <div className="category-card">
                            <div className="category-icon"><img src={videolect} width={60} alt="" /></div>
                            <h5 className="fw-semibold">Video Lecture Courses</h5>
                            <p className="text-muted mb-4">2 Courses</p>
                            <button className="category-btn"><i className="bi bi-arrow-right"></i></button>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-3">
                        <div className="category-card">
                            <div className="category-icon"><img src={testseries} width={60} alt="" /></div>
                            <h5 className="fw-semibold">Test Series</h5>
                            <p className="text-muted mb-4">1 Courses</p>
                            <button className="category-btn"><i className="bi bi-arrow-right"></i></button>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-3">
                        <div className="category-card">
                            <div className="category-icon"><img src={quebank} width={60} alt="" /></div>
                            <h5 className="fw-semibold">Question Bank</h5>
                            <p className="text-muted mb-4">3 Courses</p>
                            <button className="category-btn"><i className="bi bi-arrow-right"></i></button>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-3">
                        <div className="category-card">
                            <div className="category-icon"><img src={books} width={60} alt="" /></div>
                            <h5 className="fw-semibold">Books</h5>
                            <p className="text-muted mb-4">2 Courses</p>
                            <button className="category-btn"><i className="bi bi-arrow-right"></i></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Courses;